export default {
  home: "/admin",
  applicant: "/admin/:id",
  login: "/admin/login",
  users: "/admin/users",
  userinfo: "/admin/users/:id",
  doctors: "/admin/doctors",
  department: "/admin/departments",
};
